import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  CircularProgress,
  CardMedia,
  Paper,
  Button,
  Snackbar,
  Alert
} from "@mui/material";
import api, { vendorApi } from "../../api/api";
import { useNavigate, useSearchParams } from "react-router-dom";
import PropertyGallery from "../../Pages/Propertys/propertygallery";
import ApartmentFlats from "../apartments/apartmentFlats";
import EditApartmentModal from "../apartments/EditApartmentModal";

const ViewApartment = () => {
  const [searchParams] = useSearchParams();
  const PropertyId = searchParams.get("propertyId");
  const navigate = useNavigate();

  const [propertyData, setPropertyData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const [editOpen, setEditOpen] = useState(false);
  const [editApartment, setEditApartment] = useState(null);


  useEffect(() => {
    const getProperties = async () => {
      try {
        setLoading(true);
        const response = await api.getApartmentPlotsById(PropertyId);
        console.log(response.data);
        debugger
        setPropertyData(response.data);
      } catch (err) {
        console.error("Error fetching property data:", err);
        setError("Failed to load apartment data.");
      } finally {
        setLoading(false);
      }
    };

    if (PropertyId) getProperties();
  }, [PropertyId]);

  const handleClick = () => {
    console.log(propertyData.apartment);
    navigate('/property/AddImages', {
      state: {
        propertyData: propertyData.apartment
      }
    });
  };




  if (loading)
    return (
      <Box display="flex" justifyContent="center" mt={5}>
        <CircularProgress />
      </Box>
    );

  if (error)
    return (
      <Box display="flex" justifyContent="center" mt={5}>
        <Typography color="error">{error}</Typography>
      </Box>
    );

  if (!propertyData) return null;

  const { apartment, flats, images = [], owner_details, videos = [] } = propertyData;

  console.log(apartment);
  debugger
  return (
    <Box p={{ xs: 1, lg: 3 }}>
      {/* Apartment Details */}
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} md={5}>
          <CardMedia
            component="img"
            height="300"
            image={apartment.IconUrl}
            alt={apartment.ApartmentName}
            sx={{ borderRadius: 2 }}
          />
        </Grid>

        <Grid item xs={12} md={7}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h5" color="#3590d5">
              {apartment.ApartmentName}
            </Typography>

            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                setEditApartment({
                  apartment,
                  owner_details
                });
                setEditOpen(true);
              }}
            >
              Edit
            </Button>

          </Box>

          <Typography variant="body2">{apartment.Address}, {apartment.City}</Typography>
          <Grid container spacing={2} mt={2}>
            <Grid item xs={6}><strong>Total Units:</strong> {apartment.TotalUnits}</Grid>
            <Grid item xs={6}><strong>Total Blocks:</strong> {apartment.TotalBlocks}</Grid>
            <Grid item xs={6}><strong>Total Floors:</strong> {apartment.TotalFloors}</Grid>
            <Grid item xs={6}><strong>Land Area:</strong> {apartment.LandArea}</Grid>
            <Grid item xs={6}><strong>Construction Status:</strong> {apartment.Construction_Status}</Grid>
            {apartment.PercentageAmount == null && apartment.SqftAmount != null ? (
              <Grid item xs={6}>
                <strong>Commission Amount per sqft:</strong> {apartment.SqftAmount}
              </Grid>
            ) : apartment.SqftAmount == null && apartment.PercentageAmount != null ? (
              <Grid item xs={6}>
                <strong>Commission Percentage:</strong> {apartment.PercentageAmount}%
              </Grid>
            ) : (
              <Grid item xs={6}>
                <strong>Commission Amount:</strong> N/A
              </Grid>
            )}
            {apartment.VendorName && <Grid item xs={6}><strong>Vendor:</strong> {apartment.VendorName}</Grid>}
          </Grid>


        </Grid>
      </Grid>

      {/* About Project */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>About the Project</Typography>
        <Typography variant="body2">{apartment.Description}</Typography>
      </Paper>

      {/* Amenities */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Typography variant="h6" gutterBottom>Amenities</Typography>
        <Box display="flex" flexWrap="wrap" gap={1}>
          {apartment?.Amenities?.map((a, i) => <Button key={i} variant="outlined" size="small">{a.name}</Button>)}
        </Box>
      </Paper>

      {/* Flats */}
      
      <ApartmentFlats flats={flats} apartmentId={apartment.Id}/>

      {/* Owner Details */}
      {owner_details && owner_details.length > 0 && (
        <Paper sx={{ p: 3, mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Owner Details
          </Typography>

          {owner_details.map((owner, index) => (
            <Grid container spacing={2} key={index}>
              <Grid item xs={12} md={6}>
                <strong>Name:</strong> {owner.owner_name}
              </Grid>

              <Grid item xs={12} md={6}>
                <strong>Mobile:</strong> {owner.owner_mobile}
              </Grid>

              <Grid item xs={12} md={6}>
                <strong>Email:</strong> {owner.owner_email}
              </Grid>

              <Grid item xs={12} md={6}>
                <strong>Address:</strong> {owner.owner_address}
              </Grid>

              {owner.reference_name && (
                <Grid item xs={12} md={6}>
                  <strong>Reference Name:</strong> {owner.reference_name}
                </Grid>
              )}

              {owner.reference_mobile && (
                <Grid item xs={12} md={6}>
                  <strong>Reference Mobile:</strong> {owner.reference_mobile}
                </Grid>
              )}
            </Grid>
          ))}
        </Paper>
      )}

      {/* Gallery */}
      <Paper sx={{ p: 3, mb: 4 }}>
        <Box display="flex" justifyContent="flex-end" sx={{ mt: 3 }}>
          <Button variant="contained" onClick={handleClick}>
            Add Images
          </Button>
        </Box>
        {/* Property Gallery Component */}
        <PropertyGallery
          imageData={images}
          ProjectId={PropertyId}
          type={apartment?.PropertyType || 'N/A'}
        />

      </Paper>



      {/* Videos */}
      {videos.length > 0 && (
        <Paper sx={{ p: 3, mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            Project Videos
          </Typography>

          <Grid container spacing={2}>
            {videos.map((video, index) => {
              const videoId =
                video.includes("youtu.be")
                  ? video.split("youtu.be/")[1]
                  : video.split("v=")[1];

              return (
                <Grid
                  item
                  xs={12}      // mobile → 1 per row
                  sm={6}       // tablet → 2 per row
                  md={4}       // desktop → 3 per row ✅
                  key={index}
                >
                  <Box
                    sx={{
                      position: "relative",
                      paddingTop: "56.25%", // 16:9 ratio
                      borderRadius: 2,
                      overflow: "hidden",
                      boxShadow: "0 2px 6px rgba(0,0,0,0.15)"
                    }}
                  >
                    <iframe
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={`Video ${index + 1}`}
                      allowFullScreen
                      style={{
                        position: "absolute",
                        inset: 0,
                        width: "100%",
                        height: "100%",
                        border: "none"
                      }}
                    />
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Paper>
      )}


      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <EditApartmentModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        apartmentId={apartment?.Id}
        onUpdated={async () => {
          // Refresh property data after update
          try {
            const response = await api.getApartmentPlotsById(PropertyId);
            setPropertyData(response.data);
            // setSnackbar({ open: true, message: "Apartment updated successfully!", severity: "success" });
          } catch (err) {
            console.error(err);
            // setSnackbar({ open: true, message: "Failed to refresh data", severity: "error" });
          }
        }}
      />

    </Box>
  );
};

export default ViewApartment;
